export const aboutContent = {
  brandName: "樱花漫画网",
  brandIntro: "樱花漫画网成立于2020年，是国内领先的免费漫画在线阅读平台。我们致力于为广大漫画爱好者提供海量、优质、免费的漫画资源，涵盖韩漫、日漫、国漫等多种类型，让每一位读者都能在这里找到心仪的作品。",
  mission: "我们的使命是打破漫画阅读的门槛，让优秀的漫画作品触手可及。无论你身在何处，只要有网络，就能随时随地免费看漫画，追更不花一分钱。",
  features: [
    {
      icon: "ri-book-open-line",
      title: "海量资源",
      description: "收录数万部优质漫画作品，涵盖韩漫、日漫、国漫等多种类型，每日持续更新，满足各类读者的阅读需求。",
    },
    {
      icon: "ri-money-cny-circle-line",
      title: "完全免费",
      description: "所有漫画资源永久免费，无需付费订阅，无需购买章节，真正做到让每个人都能轻松享受漫画的乐趣。",
    },
    {
      icon: "ri-smartphone-line",
      title: "随时随地",
      description: "支持电脑、平板、手机多端阅读，自适应各种屏幕尺寸，让你随时随地畅享漫画世界。",
    },
    {
      icon: "ri-file-list-line",
      title: "下拉式阅读",
      description: "采用流畅的下拉式阅读体验，一滑到底，无需翻页，带来沉浸式的连续阅读享受。",
    },
    {
      icon: "ri-speed-up-line",
      title: "极速更新",
      description: "紧跟各大漫画平台的更新节奏，第一时间同步最新章节，让追更不再等待。",
    },
    {
      icon: "ri-shield-check-line",
      title: "安全可靠",
      description: "网站采用先进的加密技术，保护用户隐私安全，无弹窗广告干扰，提供纯净的阅读环境。",
    },
  ],
  testimonials: [
    {
      name: "漫画迷小王",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20anime%20style%20portrait%2C%20friendly%20smile%2C%20clean%20minimal%20background%2C%20simple%20illustration&width=100&height=100&seq=avatar-01&orientation=squarish",
      rating: 5,
      comment: "樱花漫画网真的是宝藏网站！资源超全，韩漫日漫国漫都有，更新速度也很快。最重要的是完全免费，强烈推荐给所有漫画爱好者！",
      date: "2026-07-20",
    },
    {
      name: "二次元少女",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20anime%20style%20portrait%2C%20cute%20smile%2C%20clean%20minimal%20background%2C%20simple%20illustration&width=100&height=100&seq=avatar-02&orientation=squarish",
      rating: 5,
      comment: "用了很多漫画网站，樱花漫画网的阅读体验是最好的。下拉式阅读太方便了，一口气能看几百话，根本停不下来！",
      date: "2026-07-18",
    },
    {
      name: "追漫达人",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20anime%20style%20portrait%2C%20cool%20expression%2C%20clean%20minimal%20background%2C%20simple%20illustration&width=100&height=100&seq=avatar-03&orientation=squarish",
      rating: 5,
      comment: "每天必刷的网站！分类清晰，找漫画特别方便。热门推荐也很准，帮我发现了好多冷门好漫画。已经推荐给身边所有朋友了。",
      date: "2026-07-15",
    },
    {
      name: "职场摸鱼人",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20anime%20style%20portrait%2C%20gentle%20smile%2C%20clean%20minimal%20background%2C%20simple%20illustration&width=100&height=100&seq=avatar-04&orientation=squarish",
      rating: 4,
      comment: "午休时间必看的漫画网站，韩漫的恋爱题材太戳我了！画风精美，剧情在线，每天都有新章节，追更完全不用花钱。",
      date: "2026-07-12",
    },
  ],
  stats: [
    { value: "50,000+", label: "漫画资源" },
    { value: "1,200万+", label: "月活用户" },
    { value: "99.9%", label: "服务可用率" },
    { value: "300万+", label: "日阅读量" },
  ],
  faqs: [
    {
      question: "樱花漫画网真的完全免费吗？",
      answer: "是的，樱花漫画网承诺所有漫画资源永久免费。我们通过广告和其他方式维持运营，不会向用户收取任何费用。您可以放心阅读所有漫画，无需担心付费问题。",
    },
    {
      question: "漫画更新频率是怎样的？",
      answer: "我们的更新团队每日工作，紧跟各大官方平台的更新节奏，确保在第一时间同步最新章节。热门漫画通常能在官方更新后数小时内上线。",
    },
    {
      question: "支持哪些设备阅读？",
      answer: "樱花漫画网支持电脑、平板和手机等所有主流设备。网站采用响应式设计，会自动适配不同屏幕尺寸，为您提供最佳的阅读体验。",
    },
    {
      question: "如何找到我想看的漫画？",
      answer: "您可以通过顶部导航栏按分类（韩漫、日漫、国漫）浏览，也可以使用首页的搜索功能直接搜索漫画名称。此外，首页的热门推荐和最新更新区域也能帮您发现好漫画。",
    },
    {
      question: "漫画阅读方式是什么样的？",
      answer: "我们采用下拉式阅读模式，所有内容在一个页面内连续展示，您只需向下滚动即可持续阅读，无需点击翻页按钮，带来流畅的沉浸式阅读体验。",
    },
  ],
  contact: {
    address: "中国广东省广州市天河区天河路385号太古汇1座",
    email: "contact@sakuramanga.com",
    phone: "020-8888-6666",
    wechat: "樱花漫画网官方",
    weibo: "@樱花漫画网",
  },
};